import { IS_HOTMART_DOMAIN } from '@space-shell/constant/domain'
import cookie from 'cookie'

const path = '/'

class CookieUtils {
  static setCookie(key: string, value: string) {
    document.cookie = cookie.serialize(key, value, {
      path,
      ...(IS_HOTMART_DOMAIN && { domain: process.env.COOKIE_DOMAIN })
    })
  }

  static getCookieByKey(appCookies: string, key: string) {
    const parsedCookie = cookie.parse(appCookies)

    return parsedCookie[key]
  }
}

export default CookieUtils
